import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../core/services/api.service';

@Component({
    selector: 'app-zoho-authenticate-page',
    templateUrl: './zoho-authenticate-page.component.html',
    styleUrls: ['./zoho-authenticate-page.component.css'],
})
export class ZohoAuthenticatePageComponent implements OnInit, OnDestroy {

    zohoQueryParams: any; // Replace any with the correct type
    clientId: string;
    redirectUri: string;
    hasRefreshToken: boolean;
    authUrl: string;
    staticQueryParams: string;
    authorizationCode: string;
    seconds: number = 5;
    countdownInterval: any; // cannot infer type from usage

    constructor(
        private api: ApiService,
        private route: ActivatedRoute,
        private router: Router,
    ) {}

    ngOnInit(): void {
        this.loadZohoQueryParams();
        this.subscribeToQueryParams();
        this.initializeAuthUrl();
    }

    loadZohoQueryParams(): void {
        this.api.get('zoho/get-zoho-configuration').subscribe(response => {
            this.hasRefreshToken = response['has_refresh_token'];
            this.clientId = response['client_id'];
            this.redirectUri = response['redirect_uri'];
        });
        console.log(this.redirectUri);
    }

    subscribeToQueryParams(): void {
        this.route.queryParams.subscribe(params => {
            const code = params['code'];
            if (code) {
                this.handleAuthorizationCode(code);
            }
        });
    }

    handleAuthorizationCode(code: string): void {
        this.authorizationCode = code;
        this.api.post('zoho/generate-refresh-token', { authorization_code: code }).subscribe(response => {
            if (response['success']) {
                this.startCountdown();
            }
        });
    }

    initializeAuthUrl(): void {
        this.authUrl = 'https://accounts.zoho.com/oauth/v2/auth';
        // eslint-disable-next-line max-len
        this.staticQueryParams = '?scope=ZohoRecruit.modules.ALL,ZohoRecruit.users.ALL,ZohoRecruit.settings.ALL&response_type=code&access_type=offline';
    }

    redirectToExternalLink(): void {
        const fullUrl = `${this.authUrl}${this.staticQueryParams}&client_id=${this.clientId}&redirect_uri=${this.redirectUri}`;
        window.location.href = fullUrl;
    }

    startCountdown(): void {
        this.countdownInterval = setInterval(() => {
            this.seconds--;

            if (this.seconds <= 0) {
                this.redirect();
            }
        }, 1000); // Update every second
    }

    redirect(): void {
        clearInterval(this.countdownInterval);
        this.router.navigate(['']);
    }

    ngOnDestroy(): void {
        clearInterval(this.countdownInterval);
    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/zoho/zoho-authenticate/zoho-authenticate-page.component.ts